/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — checkin/registration page
 *   extends:   Route
 *   template:  none
 *   model:     none (model() returns undefined; controller loads data via
 *              loadDataTask)
 *   key:       model, setupController, resetController
 *   uses:      controllerFor('application') — collapses showCart/showMenu
 *              chrome; controller.loadDataTask
 *   siblings:  controllers/checkin.js
 *   tests:     tests/unit/routes/simple-routes-test.js,
 *              tests/acceptance/checkin-register-test.js,
 *              tests/acceptance/checkin-stale-cart-test.js
 *
 * Checkin/registration route for the e-commerce storefront.
 */
import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class CheckinRoute extends Route {
  model() {}

  setupController(controller /*, model*/) {
    const application = this.controllerFor('application');
    controller.loadDataTask.perform();
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
